<template>
  <div>
    <div>
      <div class="float-left hyp-text-outsides">
        <span>{{ min }} Days</span><br />
        <span class="ml-1">{{ todayMinusFormatted }}</span>
      </div>
      <div class="float-left text-center hyp-text-inside application-heading">
        <span class="application-heading"
          >{{ currentStart }} → {{ currentEnd }}</span
        >
      </div>
      <div class="float-left hyp-text-outsides text-right">
        <span>Today</span><br />
        <span>{{ todayFormatted }}</span>
      </div>
      <div class="clearfix"></div>
    </div>
    <v-range-slider
      v-model="range"
      :max="max"
      :min="min"
      @end="handleOnEnd"
      hide-details
      thumb-color="primary"
      track-color="grey lighten-2"
      track-fill-color="grey lighten-2"
      class="align-center"
    ></v-range-slider>
    <div class="warning-message" v-if="message">{{ message }}</div>
  </div>
</template>

<script>
import lodashIsEqual from "lodash/isEqual";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

import {
  nowUtc,
  getFormattedDateNoYear,
  getTodayStartEndDate,
} from "@/common/date.utilities";

const EMITTED_ACTIONS = {
  CHANGE: "change",
};

export default {
  name: "SearchFilterDateRange",
  props: {
    dateRangeStartDaysBack: {
      type: Number,
    },
    reset: {
      type: String,
    },
    selectedRange: {
      type: Array,
    },
  },
  data() {
    return {
      min: -60,
      max: 0,
      range: this.getDefaultRange(),
      message: null,
    };
  },
  computed: {
    todayFormatted() {
      return getFormattedDateNoYear(nowUtc);
    },
    todayMinusFormatted() {
      const d = dayjs(nowUtc).subtract(Math.abs(this.min), "day");
      return getFormattedDateNoYear(d);
    },
    currentStart() {
      const d = dayjs(nowUtc).subtract(Math.abs(this.range[0]), "day");
      return getFormattedDateNoYear(d);
    },
    currentEnd() {
      const d = dayjs(nowUtc).subtract(Math.abs(this.range[1]), "day");
      return getFormattedDateNoYear(d);
    },
  },
  methods: {
    handleOnEnd() {
      const start = getTodayStartEndDate(
        dayjs(nowUtc).subtract(Math.abs(this.range[0]), "day")
      ).start;
      const end =
        this.range[1] === 0
          ? null
          : getTodayStartEndDate(
              dayjs(nowUtc).subtract(Math.abs(this.range[1]), "day")
            ).end;

      this.$emit(EMITTED_ACTIONS.CHANGE, {
        range: this.range,
        start: start,
        end: end,
      });
    },
    getDefaultRange() {
      return [-1 * this.dateRangeStartDaysBack, 0];
    },
  },
  watch: {
    reset: {
      handler() {
        this.range = this.getDefaultRange();
        this.handleOnEnd();
      },
    },
    selectedRange: {
      handler(newVal, oldVal) {
        if (lodashIsEqual(newVal, oldVal)) {
          // This was triggering without a real value change. Skip updating if nothing has changed.
          return;
        }
        if (
          this.selectedRange &&
          this.selectedRange.length > 1 &&
          this.selectedRange[0] < this.min &&
          this.selectedRange[1] < this.min
        ) {
          this.message =
            "Your search's dates exceed the minimum for Events AI. Only Verified will be displayed.";
        } else {
          this.message = null;
        }
        this.range = this.selectedRange
          ? this.selectedRange
          : this.getDefaultRange();
        this.handleOnEnd();
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
.hyp-text-outsides {
  width: 20%;
  font-size: 10px;
}
.hyp-text-inside {
  width: 60%;
  font-size: 14px;
}
.warning-message {
  color: red;
  font-size: 10px;
}
</style>
